import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import extend from 'extend';
import forceFloat from '../../../../util/force-float';

const styles = {
  wrapper: {
    flexGrow: 1,
  },
};

class SingleFeedbackVisualizer extends Component {
  render() {
    const { options, categoryKey, category } = this.props;

    const highchartOptions = {
      chart: {
        type: 'bar',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: '200',
      },
      title: {
        text: '',
      },
      subtitle: {
        text: '',
      },
      xAxis: {
        categories: ['5 Sterne', '4 Sterne', '3 Sterne', '2 Sterne', '1 Stern'],
        title: {
          text: null,
        },
      },
      yAxis: {
        min: 0,
        title: {
          align: 'high',
        },
        labels: {
          overflow: 'justify',
        },
      },
      tooltip: {
        valueSuffix: ' Bewertungen',
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      series: [{
        name: '',
        data: [4, 3, 1, 0, 0],
      }],
    };

    // merge additional options
    extend(true, highchartOptions, options);

    const containerId = `rating_${categoryKey}`;
    const opt = { ...highchartOptions };
    const values = [];
    for (let i = 1; i <= 5; i++) {
      values.push(+category[i] || 0);
    }

    extend(true, opt, {
      yAxis: {
        title: {
          text: categoryKey,
        },
      },
      series: [{
        name: categoryKey,
        data: values.reverse(),
      }],
    });
    const average = forceFloat(category.Avg);
    let stars = '';
    const starCount = Math.round(average);
    for (let i = 0; i < starCount; i++) {
      stars += '★';
    }

    for (let i = starCount; i < 5; i++) {
      stars += '☆';
    }

    const count = values.reduce((a, b) => a + b, 0);
    return (
      <div style={styles.wrapper}>
        <div className="col col-lg-3">
          <span className="subheader">{`${stars} |  Ø ${(+average).toFixed(1)}(${count}) `}</span>
          <div id={containerId} />
        </div>
        <HighchartsReact key={containerId} highcharts={Highcharts} options={opt} />
      </div>
    );
  }
}

SingleFeedbackVisualizer.propTypes = {
  categoryKey: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  category: PropTypes.object.isRequired,
};

export default SingleFeedbackVisualizer;
